export type Cat = "反转" | "打脸" | "辟谣" | "实锤" | "追踪";

export const navTabs: { id: string; label: string }[] = [
  { id: "reverse", label: "反转大事件" },
  { id: "slap", label: "打脸实录" },
  { id: "fact", label: "辟谣求真" },
  { id: "proof", label: "实锤有据" },
  { id: "follow", label: "后续追踪" },
];

export const tickerItems: string[] = [
  "「深水区火锅」再发声：否认后晒出无剪辑监控，围观网友称打脸预定",
  "平台辟谣：网传聊天截图系拼接，原始后台未检出对应会话",
  "带货主播@三斤半 就过期品风波二度致歉，口径与前一日不一致",
  "品牌方晒采购质检单反驳造假指控，反转行情持续发酵中",
  "@真相锤 公开维权立案回执，称将持续跟进事件后续",
  "涉事机构改口承认数据注水，实锤证据链再添一环",
  "多方对同一聊天记录各执一词，真假验证仍待原始日志",
];

export interface Featured {
  id: number;
  area: string;
  flag: string;
  title: string;
  summary: string;
  src: string;
  meta: string;
  time: string;
  views: string;
}

export const featuredSlides: Featured[] = [
  {
    id: 1,
    area: "反转大事件 · 封面焦点",
    flag: "三连反转专题",
    title: "同一份回应，三种说法：一场带货纠纷的反转、打脸与辟谣全复盘",
    summary:
      "从声明否认、晒单自证，到第三方复核推翻口径，再到多方证据互相冲突。我们按时间线把真假、实锤与后续追踪逐条摆上桌，帮你理清每一次关键反转的来龙去脉。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20overlapping%20newspaper%20clippings%20and%20chat%20message%20bubbles%20arranged%20into%20a%20giant%20question%20mark%2C%20a%20magnifying%20glass%20hovering%20at%20the%20center%2C%20crimson%20red%20and%20deep%20ink%20color%20palette%2C%20torn%20paper%20with%20tape%20and%20verification%20stamps%2C%20high%20contrast%20magazine%20front%20cover%20composition%2C%20documentary%20collage%20art%20style%2C%20detailed%20textures&width=1280&height=680&seq=feat-reverse-cover-01&orientation=landscape",
    meta: "复盘 · 还原前因后果",
    time: "2026-09-05 09:20",
    views: "195.4万",
  },
  {
    id: 2,
    area: "辟谣求真 · 真假实验室",
    flag: "技术辟谣专题",
    title: "「实锤原图」真的存在吗？一次截图风波的技术还原与真假验证",
    summary:
      "网传核心证据是真是假？我们从文件指纹、时间戳到像素拼接痕迹逐步拆解，用可复现的方式给出辟谣结论，并对仍存疑的部分标记待回应，供事件后续持续追踪。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20a%20magnifying%20glass%20inspecting%20split%20half%20color%20negative%20photo%20strips%20and%20ruler%20measuring%20overlays%2C%20document%20fingerprint%20and%20pixel%20grid%20motif%2C%20warm%20gold%20and%20deep%20ink%20palette%20with%20red%20accents%2C%20newsprint%20grain%2C%20investigative%20fact%20check%20front%20page%20collage%2C%20high%20detail&width=1280&height=680&seq=feat-factcheck-cover-02&orientation=landscape",
    meta: "真假验证 · 证据链拆解",
    time: "2026-09-05 08:40",
    views: "88.2万",
  },
];

export interface Ranking {
  rank: number;
  title: string;
  heat: string;
  delta: string;
  cat: string;
}

export const hotRankings: Ranking[] = [
  { rank: 1, title: "「三斤半」就过期品风波再度致歉，口径反转", heat: "326.1万", delta: "↑ 平", cat: "反转" },
  { rank: 2, title: "深水区火锅晒无剪辑监控，网友等待打脸结局", heat: "289.7万", delta: "↑12", cat: "追踪" },
  { rank: 3, title: "品牌方反驳造假指控，实锤证据链再添一环", heat: "244.3万", delta: "↑平", cat: "实锤" },
  { rank: 4, title: "平台辟谣：网传聊天记录系拼接截图", heat: "201.8万", delta: "↓3", cat: "辟谣" },
  { rank: 5, title: "涉事机构改口承认数据注水", heat: "177.6万", delta: "↑8", cat: "打脸" },
  { rank: 6, title: "同一聊天记录多方各执一词，真假待验", heat: "132.9万", delta: "新", cat: "真假" },
  { rank: 7, title: "代运营中介晒合同：回应后遭二次打脸", heat: "98.4万", delta: "↑2", cat: "打脸" },
  { rank: 8, title: "直播切片争议再起，后续追踪持续更新", heat: "76.2万", delta: "↑1", cat: "追踪" },
  { rank: 9, title: "维权回执公开，事件进入法律程序阶段", heat: "61.8万", delta: "新", cat: "后续" },
  { rank: 10, title: "旧料重翻引围观，辟谣称时间线被剪辑", heat: "43.5万", delta: "↓1", cat: "辟谣" },
];

export interface FeedItem {
  id: number;
  cat: string;
  title: string;
  summary: string;
  src: string;
  time: string;
  heat: string;
  tag?: string;
}

export const feedItems: FeedItem[] = [
  {
    id: 1,
    cat: "反转",
    title: "称「从未承诺全额退款」遭晒记录，口径再反转",
    summary: "官方售后聊天记录流出，与此前公开说法冲突，网友涌入要求给个解释。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20chat%20log%20panels%20flipped%20upside%20down%20with%20a%20red%20rotate%20arrow%2C%20magnifier%20and%20torn%20receipt%20paper%2C%20crimson%20red%20ink%20palette%20with%20paper%20grain%2C%20modern%20news%20feed%20card%20artwork%2C%20symbolic%20documentary%20illustration&width=720&height=460&seq=feed-reverse-01&orientation=landscape",
    time: "2026-09-05 10:12",
    heat: "12.6万",
    tag: "风向已变",
  },
  {
    id: 2,
    cat: "实锤",
    title: "采购质检单流出，虚假宣传指控被正面反驳",
    summary: "第三方机构盖章报告指向与指控相悖，支持与质疑两派仍在争论取样范围。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20an%20official%20stamped%20report%20document%20and%20seal%20on%20a%20clipboard%2C%20red%20rubber%20stamp%20motif%2C%20deep%20ink%20and%20crimson%20palette%2C%20paper%20texture%2C%20evidence%20based%20investigative%20news%20collage%20art%2C%20high%20detail&width=720&height=460&seq=feed-proof-02&orientation=landscape",
    time: "2026-09-05 09:48",
    heat: "9.8万",
    tag: "有新证据",
  },
  {
    id: 3,
    cat: "辟谣",
    title: "官方辟谣「跑路」传闻：系旧视频被二次剪辑",
    summary: "门店监控完整版公开，时间戳自洽，网传版本存在明显跳帧。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20megaphone%20and%20a%20check%20shield%20with%20quotation%20marks%20crossed%20out%2C%20film%20frame%20edges%20and%20timestamp%20motif%2C%20warm%20gold%20and%20ink%20palette%2C%20newsprint%20texture%2C%20rumor%20debunk%20news%20card%20illustration%2C%20symbolic%20documentary%20style&width=720&height=460&seq=feed-rumor-03&orientation=landscape",
    time: "2026-09-05 09:15",
    heat: "8.1万",
    tag: "已核实",
  },
  {
    id: 4,
    cat: "打脸",
    title: "说好的「永不降价」三天后被自家活动页打脸",
    summary: "同款商品活动价截图被大量转发，声明评论区已被网友考古现场覆盖。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20two%20price%20tags%20colliding%20with%20a%20red%20impact%20star%20and%20palm%20print%20silhouette%2C%20contrast%20of%20words%20versus%20action%2C%20crimson%20red%20and%20ink%20palette%2C%20collage%20paper%20texture%2C%20satire%20news%20card%20illustration%2C%20bold%20composition&width=720&height=460&seq=feed-slap-04&orientation=landscape",
    time: "2026-09-05 08:50",
    heat: "7.4万",
    tag: "翻车现场",
  },
  {
    id: 5,
    cat: "追踪",
    title: "首份联合声明发布，事件后续出现缓和信号",
    summary: "双方就退款与赔偿细则达成初步框架，仍待履约细则与到账时间兑现。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20two%20document%20scrolls%20binding%20together%20with%20a%20ribbon%20knot%2C%20hands%20shaking%20over%20papers%2C%20muted%20crimson%20and%20warm%20gray%20palette%2C%20paper%20texture%2C%20settlement%20and%20follow-up%20news%20collage%20art%2C%20elegant%20documentary%20style&width=720&height=460&seq=feed-follow-05&orientation=landscape",
    time: "2026-09-05 08:20",
    heat: "6.9万",
    tag: "新进展",
  },
  {
    id: 6,
    cat: "辟谣",
    title: "「后台跑路」截图系编造，运营后台仍在正常更新",
    summary: "平台侧给出访问与操作记录，配合辟谣时间线基本闭合。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20server%20dashboard%20interface%20panels%20with%20a%20verification%20check%20and%20broken%20chain%20link%20motif%2C%20magnifying%20glass%20overlay%2C%20warm%20gold%20and%20ink%20palette%2C%20pixel%20grid%20and%20paper%20texture%2C%20rumor%20debunk%20technology%20news%20card%2C%20detailed&width=720&height=460&seq=feed-rumor-06&orientation=landscape",
    time: "2026-09-05 07:55",
    heat: "5.3万",
    tag: "已辟谣",
  },
  {
    id: 7,
    cat: "反转",
    title: "第三方鉴定推翻此前结论，事件走向再度反转",
    summary: "新的鉴定口径与此前公开版本存在出入，涉事方称将公布原始样本。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20a%20laboratory%20flask%20and%20report%20swapping%20verdicts%20with%20two%20opposing%20arrows%20crossing%2C%20red%20and%20deep%20ink%20palette%2C%20blueprint%20grid%20and%20paper%20texture%2C%20evidence%20reversal%20news%20collage%20art%2C%20dynamic%20composition&width=720&height=460&seq=feed-reverse-07&orientation=landscape",
    time: "2026-09-05 07:30",
    heat: "4.7万",
    tag: "风向已变",
  },
  {
    id: 8,
    cat: "实锤",
    title: "内部邮件截图流出，曾提到「宣传口径统一」",
    summary: "截图内容引发联想，真伪仍待原始邮箱与上下文核实。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20paper%20emails%20and%20an%20envelope%20with%20an%20evidence%20folder%2C%20paperclip%20and%20stamp%20motif%2C%20magnifier%2C%20crimson%20red%20and%20warm%20ink%20palette%2C%20archive%20collage%20art%2C%20investigative%20leak%20news%20card%2C%20detailed%20textures&width=720&height=460&seq=feed-proof-08&orientation=landscape",
    time: "2026-09-05 06:45",
    heat: "4.1万",
    tag: "存疑",
  },
];

export interface ReversalRow {
  index: string;
  round: string;
  subject: string;
  title: string;
  src: string;
  before: string;
  after: string;
  verdict: string;
  heat: string;
}

export const reversalRows: ReversalRow[] = [
  {
    index: "01",
    round: "第一轮 · 否认",
    subject: "@三斤半 · 过期品风波",
    title: "先是否认，随后又被自家直播切片打脸",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20live%20broadcast%20camera%20silhouette%20in%20front%20of%20a%20wall%20of%20product%20boxes%20with%20a%20warning%20sign%2C%20red%20spotlight%2C%20deep%20ink%20and%20crimson%20palette%2C%20grain%20texture%2C%20expos%C3%A9%20news%20feature%20illustration%2C%20dramatic%20documentary%20style&width=760&height=480&seq=rev-row-01&orientation=landscape",
    before: "主播直播中称「绝无过期，可调全部批次记录」。",
    after: "同日第三方抽查口径与其矛盾，原声明随即下架重发。",
    verdict: "首轮否认未能站住，进入实锤与辟谣拉锯。",
    heat: "189.2万",
  },
  {
    index: "02",
    round: "第二转 · 晒单",
    subject: "品牌方 · 造假指控",
    title: "晒出质检单反击，却被网友扒出取样日期存疑",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20stacked%20official%20documents%20being%20examined%20under%20a%20bright%20lamp%2C%20a%20checklist%20sheet%20and%20date%20stamp%20floating%2C%20gold%20and%20ink%20palette%20with%20red%20annotation%20marks%2C%20forensic%20news%20collage%2C%20high%20detail%20documentary%20style&width=760&height=480&seq=rev-row-02&orientation=landscape",
    before: "品牌方公开第三方质检单，称指控「纯属造谣」。",
    after: "网友与同行质疑取样批次与时间窗口，官方称将补充说明。",
    verdict: "反击动作激起更大追问，真假仍需原始凭证。",
    heat: "164.7万",
  },
  {
    index: "03",
    round: "第三轮 · 改口",
    subject: "涉事机构 · 数据注水",
    title: "从拒不承认到主动改口，声明前后矛盾被打脸",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20torn%20statement%20paper%20revealing%20layered%20contradictions%20beneath%2C%20red%20editing%20marks%20and%20strikethrough%20lines%2C%20folded%20document%2C%20crimson%20and%20ink%20palette%2C%20print%20grain%2C%20exposure%20news%20feature%20art%2C%20compelling%20composition&width=760&height=480&seq=rev-row-03&orientation=landscape",
    before: "机构声明措辞强硬，否认任何数据注水行为。",
    after: "面对实锤证据链，改口承认部分口径确有出入。",
    verdict: "主动改口等于承认，实锤与打脸双标签加身。",
    heat: "221.5万",
  },
];

export interface FaceSlapRow {
  id: number;
  subject: string;
  before: string;
  after: string;
  result: string;
  heat: string;
}

export const faceSlapRows: FaceSlapRow[] = [
  { id: 1, subject: "@深水区火锅", before: "「监控已删，绝无克扣」", after: "次日放出无剪辑原盘", result: "打脸 · 自证打脸反转", heat: "98.6万" },
  { id: 2, subject: "某代运营中介", before: "「合同白纸黑字」", after: "晒出的合同反证对方说法", result: "二次打脸", heat: "74.1万" },
  { id: 3, subject: "@三斤半", before: "「支持全程溯源」", after: "溯源链接一度无法打开", result: "打脸 · 已回填", heat: "61.3万" },
  { id: 4, subject: "某课程机构", before: "「90天无效退费」", after: "退费条款被扒为「仅限首月」", result: "实锤打脸", heat: "52.7万" },
  { id: 5, subject: "@说真话的猫", before: "预告「重磅实锤在路」", after: "放出的所谓证据实为旧闻拼接", result: "自爆式打脸", heat: "46.2万" },
  { id: 6, subject: "某品牌客服", before: "「已按承诺处理」", after: "工单记录显示多次催促未兑现", result: "打脸 · 已致歉", heat: "38.9万" },
];

export type Verdict = "真" | "假" | "存疑";

export interface FactCheck {
  id: number;
  claim: string;
  verdict: Verdict;
  detail: string;
  time: string;
}

export const factChecks: FactCheck[] = [
  {
    id: 1,
    claim: "「涉事门店已连夜跑路关门」",
    verdict: "假",
    detail: "门店后台仍正常营业与更新，网传为旧视频二次剪辑，时间线不自洽。",
    time: "09:15 更新",
  },
  {
    id: 2,
    claim: "「主播直播中说过的原话」",
    verdict: "真",
    detail: "已比对三路完整回放，关键表述与流传字幕一致，上下文无断章。",
    time: "08:50 更新",
  },
  {
    id: 3,
    claim: "「品牌被要求全额退款给所有人」",
    verdict: "存疑",
    detail: "仅见单张客服截图，未获官方公告佐证，退款范围仍在求证。",
    time: "08:12 更新",
  },
  {
    id: 4,
    claim: "「质检报告系伪造 P 图」",
    verdict: "假",
    detail: "已调取第三方官网存档编号，报告真实存在，争议点仅在取样口径。",
    time: "07:40 更新",
  },
  {
    id: 5,
    claim: "「内部邮件泄露坐实造假」",
    verdict: "存疑",
    detail: "邮件上下文缺失、发件时间未验证，尚不能作为实锤证据使用。",
    time: "07:05 更新",
  },
  {
    id: 6,
    claim: "「之前承诺过 30 天无理由退差价」",
    verdict: "真",
    detail: "页面快照与客服记录互相印证，确有公开承诺在先，后续执行存疑。",
    time: "06:30 更新",
  },
];

export interface EvidenceCard {
  id: number;
  title: string;
  kind: string;
  level: "高" | "中";
  summary: string;
  src: string;
  time: string;
}

export const evidenceCards: EvidenceCard[] = [
  {
    id: 1,
    title: "回放与字幕逐句比对，证实关键表述属实",
    kind: "影像证据 · 三方回放",
    level: "高",
    summary: "三路直播平台完整回放时间轴对齐，逐句转写一致，未检出剪辑跳帧痕迹。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20video%20timeline%20strips%20with%20playhead%20and%20subtitle%20caption%20boxes%20aligned%2C%20timecode%20readout%2C%20crimson%20and%20ink%20palette%2C%20film%20grain%2C%20media%20verification%20evidence%20card%20illustration%2C%20precise%20documentary%20art&width=760&height=460&seq=proof-card-01&orientation=landscape",
    time: "2026-09-05 09:02",
  },
  {
    id: 2,
    title: "质检报告官网存档可查，编号与机构一致",
    kind: "文件证据 · 第三方存档",
    level: "高",
    summary: "报告编号可在出具机构公开平台检索到，电子章与样例比对无异常。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20a%20certificate%20document%20with%20embossed%20seal%20and%20barcode%20being%20scanned%20by%20a%20laser%20beam%2C%20folder%20archive%2C%20warm%20gold%20and%20ink%20palette%20with%20red%20stamp%2C%20forensic%20evidence%20news%20card%2C%20detailed%20collage%20style&width=760&height=460&seq=proof-card-02&orientation=landscape",
    time: "2026-09-05 08:41",
  },
  {
    id: 3,
    title: "客服聊天记录已公证存证，链上可查",
    kind: "对话证据 · 公证存证",
    level: "中",
    summary: "关键对话已办理公证并生成存证编号，上下文完整，暂未见二次拼接。",
    src: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20chat%20bubbles%20being%20archived%20into%20a%20vault%20with%20a%20notarization%20stamp%20and%20chain%20link%20motif%2C%20timestamp%20guard%2C%20deep%20ink%20and%20crimson%20palette%2C%20legal%20evidence%20news%20card%20illustration%2C%20sharp%20documentary%20art&width=760&height=460&seq=proof-card-03&orientation=landscape",
    time: "2026-09-05 08:03",
  },
];

export interface FollowUp {
  date: string;
  title: string;
  status: "已澄清" | "新进展" | "待回应";
  text: string;
}

export const followUps: FollowUp[] = [
  { date: "2026-09-05 10:20", title: "@深水区火锅 放出监控原盘", status: "新进展", text: "自称无剪辑版本公开，网友正逐帧比对与声明口径的出入。" },
  { date: "2026-09-05 09:45", title: "品牌方回应取样质疑", status: "待回应", text: "称将于 48 小时内补充批次说明，具体时间窗口仍未给出。" },
  { date: "2026-09-04 22:30", title: "涉事机构承认部分口径有出入", status: "已澄清", text: "主动改口并致歉，称系内部沟通疏漏所致，而非故意隐瞒。" },
  { date: "2026-09-04 19:00", title: "首份联合声明发布", status: "新进展", text: "双方就退款细则达成初步框架，履约与到账时间仍待兑现观察。" },
  { date: "2026-09-04 15:20", title: "@真相锤 公开维权回执", status: "待回应", text: "事件进入法律程序阶段，后续追踪将随程序节点持续更新。" },
];

export interface CtaItem {
  icon: string;
  title: string;
  desc: string;
}

export const ctaItems: CtaItem[] = [
  { icon: "ri-megaphone-line", title: "一键爆料", desc: "你看到的可疑截图、回放与线索，都可从这里投递核验。" },
  { icon: "ri-focus-3-line", title: "约稿求证", desc: "针对仍在反转中的争议，约我们做一次逐条拆解还原。" },
  { icon: "ri-team-line", title: "追线小组", desc: "加入社区，一起盯实锤、盯打脸、盯每次关键后续。" },
];

export const footerCols: { title: string; links: string[] }[] = [
  { title: "频道导航", links: ["反转大事件", "打脸实录", "辟谣求真", "实锤有据", "后续追踪", "真假实验室"] },
  { title: "阅读方式", links: ["头条热推", "热度飙升榜", "事件时间线", "今日速览", "深度复盘", "往期归档"] },
  { title: "关于站点", links: ["关于黑料王", "核验流程", "线索来源", "编辑准则", "免责声明", "联系我们"] },
];